import { AxiosInstance } from 'axios'

import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'
import {
  CreateEmployeesWorkCardsRequest,
  UploadEmployeeWorkCardFileRequest,
} from '@modules/employees/types/EmployeesWorkCards/requests'

export class EmployeesWorkCardsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesWorkCardsRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/work-cards`, body)

    return response.data
  }

  async uploadFile({ employeeId, file }: UploadEmployeeWorkCardFileRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('file', file)

    const response = await this.instance.post(`/companies/employees/${employeeId}/work-cards/file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesWorkCardsService = (instance: AxiosInstance) => new EmployeesWorkCardsService(instance)
